import { Namespace } from 'react-i18next';

export const translatePostedTimeFromNow = (
  time: string | null,
  t: (ns: Namespace, options: Record<string, unknown>) => string
): string | null => {
  let translatedPostedTimeFromNow = time;

  // time could show "a day ago" so we put 1 as a default count
  const timeAmount = time?.match(/\d/g)?.join('') || 1;

  const count =
    typeof timeAmount === 'string' ? Number(timeAmount) : timeAmount;

  if (time?.includes('minute')) {
    translatedPostedTimeFromNow = t('date:minute_ago_with_count', { count });
  }
  if (time?.includes('hour')) {
    translatedPostedTimeFromNow = t('date:hour_ago_with_count', { count });
  }
  if (time?.includes('day')) {
    translatedPostedTimeFromNow = t('date:day_ago_with_count', { count });
  }
  if (time?.includes('month')) {
    translatedPostedTimeFromNow = t('date:month_ago_with_count', { count });
  }
  if (time?.includes('year')) {
    translatedPostedTimeFromNow = t('date:year_ago_with_count', { count });
  }

  return translatedPostedTimeFromNow;
};
